import { useEffect, useState } from 'react';
import Head from 'next/head';
import detectBrowser from 'browser-detect';

import Logo from '@/shared/Logo';

const AuthLayout = ({ title = 'Auth', children }) => {
    const [overlay, setOverlay] = useState(false);
    const [overlayMessage, setOverlayMessage] = useState('');
    useEffect(() => {
        const browser = detectBrowser();
        console.log('browser: ', browser);

        const minVersion = 110;

        if (browser.name === 'ie') {
            setOverlay(true);
            setOverlayMessage('Используйте браузер Microsoft Edge, Google Chrome или любой другой на базе Chromium.');
            return;
        }

        if (browser.name === 'chrome') {
            if (browser.versionNumber >= minVersion) return;

            setOverlay(true);
            setOverlayMessage(
                `Вы используйте браузер на базе ${browser.name === 'chrome' && 'Chromium'} версии ${browser.version},
                для корректной работы системы требуется версия ${minVersion} или новее.`
            );
            return;
        }
    }, []);

    return (
        <>
            <Head>
                <title>{title}</title>
            </Head>

            <div className="flex h-screen flex-col items-center justify-center bg-gray-400 dark:bg-block-tertiary">
                <div className="flex w-full flex-col">
                    <div className="flex h-full w-full justify-center p-20">
                        <Logo />
                    </div>
                    <div className="flex w-full">{children}</div>
                </div>
            </div>

            {overlay && (
                <div
                    className="absolute inset-0 flex flex-col items-center justify-center bg-black/60"
                    style={{ zIndex: '999' }}
                >
                    <h1 className="py-4 text-2xl font-semibold text-white dark:text-font-quarternary">
                        Устаревший браузер
                    </h1>
                    <span className="whitespace-pre-line text-center text-white dark:text-font-quarternary">
                        {overlayMessage}
                    </span>
                </div>
            )}
        </>
    );
};

export default AuthLayout;
